export interface CustomTheme {
  colors: {
    primary: string;
    secondary: string;
    highlight: string;
    ctaTextColor: string;
    sourceHighlight: string;
  };
  fontFamily: string;
}

export const getDefaultTheme = (): CustomTheme => ({
  colors: {
    primary: '#3BD4CA',
    secondary: '#032B85',
    highlight: '#cb006d',
    ctaTextColor: '#fff',
    sourceHighlight: '#00F7FF99',
  },
  fontFamily: 'Poppins',
});
